module.exports = __webpack_public_path__ + "dcaa029ffc3b8a41c08de2c271eaacea.png";